/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-26 16:51.
 */
const BaseComponent = require( 'base/base-component' );

class InqueryReverse extends BaseComponent {
  constructor(){
    super({
      events: {

      }
    })
  }
}

module.exports = InqueryReverse;
